<template>
    <div id="call-history">
        <div class="table-responsive">
            <table class="table list-table spacing-table del-table">

                <tbody class="custom-table">
                <tr
                class="hello"
                v-for="smsHistoryDataLimitedShow in smsHistoryDataLimited"
                :key="smsHistoryDataLimitedShow.id">

                    <td>{{ smsHistoryDataLimitedShow.from_number }}</td>
                    <td>{{ smsHistoryDataLimitedShow.datetime | date }}</td>
                    <td class="no-wrap text-right">
                        <p v-if="smsHistoryDataLimitedShow.sms_dispatched == '0'" class="box-danger">Not Sent</p>
                        <p v-else-if="smsHistoryDataLimitedShow.sms_dispatched == '1' && smsHistoryDataLimitedShow.sms_delivery_status == '0'" class="box-primary">Pending</p>
                        <p v-else-if="smsHistoryDataLimitedShow.sms_dispatched == '1' && smsHistoryDataLimitedShow.sms_delivery_status == '1'" class="box-success">Delivered</p>
                        <p v-else-if="smsHistoryDataLimitedShow.sms_dispatched == '1' && smsHistoryDataLimitedShow.sms_delivery_status == '2'" class="box-muted">Failed</p>
                        <p v-else>error</p>
                    </td>
                </tr>

                </tbody>
            </table>
        </div>

        <div class="load-more">
            <button type="button" class="btn btn-loadmore" data-toggle="modal" data-target="#myModal">Load more</button>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <h4 class="modal-title">SMS History</h4>
                </div>


                <div class="modal-body">
                    <div class="table-responsive tabletop">
                    <table class="table list-table spacing-table del-table">
                        <tbody class="custom-table">
                            <tr class="hello" v-for="smsHistoryDataShow in smsHistoryData" :key="smsHistoryDataShow.id">
                                <td>{{ smsHistoryDataShow.from_number }}</td>
                                <td>{{ smsHistoryDataShow.datetime | date }}</td>
                                <td class="no-wrap text-right">
                                    <p v-if="smsHistoryDataShow.sms_dispatched == '0'" class="box-danger">Not Sent</p>
                                    <p v-else-if="smsHistoryDataShow.sms_dispatched == '1' && smsHistoryDataShow.sms_delivery_status == '0'" class="box-primary">Pending</p>
                                    <p v-else-if="smsHistoryDataShow.sms_dispatched == '1' && smsHistoryDataShow.sms_delivery_status == '1'" class="box-success">Delivered</p>
                                    <p v-else-if="smsHistoryDataShow.sms_dispatched == '1' && smsHistoryDataShow.sms_delivery_status == '2'" class="box-muted">Failed</p>
                                    <p v-else>error</p>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                    </div>

                    <ul class="pager">
                        <li class="previous"><a @click="LoadPrevQrsHistory" :class="{'dontshow' : pageNum == 1}">Previous</a></li>
                        <li class="next"><a @click="LoadMoreQrsHistory" :class="{'dontshow' : pageNum == totalPage}">Next</a></li>
                        <!-- <li>{{ pageNum }}</li> -->
                    </ul>
                </div>

            </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import {getSmsHistoryUrl, getHeader} from './../../../config';

export default {
    props: ['pegination'],
    data() {
        return {
            smsHistoryData: {
                from_number: "",
                datetime: new Date(),
                sms_dispatched: '',
                sms_delivery_status: ''
            },
            smsHistoryDataLimited: {
                from_number: "",
                datetime: new Date(),
                sms_dispatched: '',
                sms_delivery_status: ''
            },
            pageNum: "",
            totalPage: ""
        }
    },
    mounted() {
        axios
        .post(getSmsHistoryUrl,{page: 1},{headers: getHeader()})
        .then(Response =>{
            this.smsHistoryData = Response.data.data;
            this.pageNum = Response.data.page_num;
            this.totalPage = Response.data.page_count;
        }),
        axios
        .post(getSmsHistoryUrl,{page: 1},{headers: getHeader()})
        .then(Response =>{
            this.smsHistoryDataLimited = Response.data.data.slice(0,3);
        })
    },
    methods: {
        LoadMoreQrsHistory(){
            axios
            .post(getSmsHistoryUrl,{page: this.pageNum+1},{headers: getHeader()})
            .then(Response =>{
                this.smsHistoryData = Response.data.data;
                this.pageNum = Response.data.page_num;
            })
        },
        LoadPrevQrsHistory(){
            axios
            .post(getSmsHistoryUrl,{page: this.pageNum-1},{headers: getHeader()})
            .then(Response =>{
                this.smsHistoryData = Response.data.data;
                this.pageNum = Response.data.page_num;
            })
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/views/parts/callhistory.vue